module.exports = __webpack_public_path__ + "static/Gnoll-0e5b00afb906304c5bb261c46a38f43b.jpg";